function fadeInElements() {
  const observerOptions = {
    root: null,
    threshold: 0,
    rootMargin: "0px 0px -20% 0px"
  };

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("in-view");
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  const fadeElements = Array.from(document.getElementsByClassName("section-fade"));
  for (let element of fadeElements) {
    observer.observe(element);
  }
}

function externalLinks() {
  // External links open in new tab and given correct props
  const links = document.links;
  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }
}

function mobileFooterAccordion() {

  const footerColumns = document.querySelectorAll('.footer-column');

  footerColumns.forEach((column, index) => {
    const heading = column.querySelector('.footer-heading-container');
    const content = column.querySelector('ul');

    // Only add click handlers if both heading and content exist
    if (heading && content && index < footerColumns.length - 1) {
      // Apply accordion functionality to all columns EXCEPT the last one
      heading.addEventListener('click', () => {
        if (column.classList.contains('open')) {
          column.classList.remove('open');
          content.style.maxHeight = null;
        } else {
          // Close other open columns
          footerColumns.forEach((otherColumn) => {
            const otherContent = otherColumn.querySelector('ul');
            if (otherContent && otherColumn !== column) {
              otherColumn.classList.remove('open');
              otherContent.style.maxHeight = null;
            }
          });

          // Open the clicked column
          column.classList.add('open');
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }
    // Automatically open the first accordion on load
    if (index === 0) {
      column.classList.add('open');
      if (content) {
        content.style.maxHeight = content.scrollHeight + "px"; // Ensure the first column is open
      }
    }
  });
}

window.addEventListener("DOMContentLoaded", event => {
  fadeInElements();
  mobileFooterAccordion();
  externalLinks();
});